module.exports = __webpack_public_path__ + "img/2-map.5dbd10b8.jpg";